import { NavLink,Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../App";
import logo from "../../../nourtunelogohome.png";
import "./Sidebar.css";
import { FaMusic, FaRegUser, FaChartBar, FaRegFileExcel } from "react-icons/fa";
import { RiAdminLine } from "react-icons/ri";
import { TbLogout2 } from "react-icons/tb";
import axios from "axios";

const Sidebar = ({ Ip }) => {
  const { isDark, setIsDark } = useContext(ThemeContext);
  const [access_role, setAccessRole] = useState("");

  useEffect(() => {
    const admin_role = localStorage.getItem("admin_role");
    if (admin_role) {
      setAccessRole(admin_role);
    }
  }, []);

  const logout = async () => {
    try {
      const formData = new FormData();
      formData.append("Action", "logout");
      const res = await axios.post(`${Ip}/Dashboard/logout.php`, formData, {
        withCredentials: true,
      });
      console.log("Logout response:", res.data);
      if (res.data.success === true) {
        localStorage.removeItem("admin_role");
        window.location.href = "/";
      } else {
        console.error("Logout failed:", res.data);
      }
    } catch (err) {
      console.error("Error logging out:", err);
    }
  };

  return (
    <div className="w-64 h-screen fixed left-0 top-0 bg-light-surface dark:bg-dark-surface text-light-text dark:text-dark-text border-r border-light-border dark:border-dark-border flex flex-col transition-colors duration-200">
      <div className="p-4 flex items-center gap-3 border-b border-light-border dark:border-dark-border">
        <Link to="/"><img src={logo} alt="Nour Tune" className="w-12 h-12 rounded" />
        </Link>
        <div className="flex-1">
          <h2 className="text-lg font-semibold tracking-tight">NourTune</h2>
          <p className="text-xs text-light-muted dark:text-dark-muted">
            Dashboard
          </p>
        </div>
        <button
          onClick={() => setIsDark(!isDark)}
          className="p-2 rounded-lg hover:bg-light-surfaceSoft dark:hover:bg-dark-surfaceSoft transition-colors"
        >
          {isDark ? "☀️" : "🌙"}
        </button>
      </div>
      <nav className="flex-1 overflow-y-auto">
        <ul className="side-list">
          <li>
            <NavLink
              to="/dashboard/analyse"
              className={({ isActive }) =>
                `side-item flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 hover:bg-light-brand/10 dark:hover:bg-dark-brand/10 hover:border-light-brand/30 dark:hover:border-dark-brand/30 ${
                  isActive
                    ? "bg-light-brand/10 dark:bg-dark-brand/10 border-light-brand/30 dark:border-dark-brand/30"
                    : ""
                }`
              }
            >
              <span className="text-light-brand dark:text-dark-brand">
                <FaChartBar size={22} />
              </span>
              <span className="font-medium">Analyse</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/dashboard/rhyms"
              className={({ isActive }) =>
                `side-item flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 hover:bg-light-brand/10 dark:hover:bg-dark-brand/10 hover:border-light-brand/30 dark:hover:border-dark-brand/30 ${
                  isActive
                    ? "bg-light-brand/10 dark:bg-dark-brand/10 border-light-brand/30 dark:border-dark-brand/30"
                    : ""
                }`
              }
            >
              <span className="text-light-brand dark:text-dark-brand">
                <FaMusic size={22} />
              </span>
              <span className="font-medium">Rhymes</span>
            </NavLink>
          </li>
          {access_role === "1" && (
            <li>
              <NavLink
                to="/dashboard/admin"
                className={({ isActive }) =>
                  `side-item flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 hover:bg-light-brand/10 dark:hover:bg-dark-brand/10 hover:border-light-brand/30 dark:hover:border-dark-brand/30 ${
                    isActive
                      ? "bg-light-brand/10 dark:bg-dark-brand/10 border-light-brand/30 dark:border-dark-brand/30"
                      : ""
                  }`
                }
              >
                <span className="text-light-brand dark:text-dark-brand">
                  <RiAdminLine size={22} />
                </span>
                <span className="font-medium">Admin</span>
              </NavLink>
            </li>
          )}
          <li>
            <NavLink
              to="/dashboard/users"
              className={({ isActive }) =>
                `side-item flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 hover:bg-light-brand/10 dark:hover:bg-dark-brand/10 hover:border-light-brand/30 dark:hover:border-dark-brand/30 ${
                  isActive
                    ? "bg-light-brand/10 dark:bg-dark-brand/10 border-light-brand/30 dark:border-dark-brand/30"
                    : ""
                }`
              }
            >
              <span className="text-light-brand dark:text-dark-brand">
                <FaRegUser size={22} />
              </span>
              <span className="font-medium">Users</span>
            </NavLink>
          </li>
          {access_role === "1" && (
            <li>
              <NavLink
                to="/dashboard/excel"
                className={({ isActive }) =>
                  `side-item flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 hover:bg-light-brand/10 dark:hover:bg-dark-brand/10 hover:border-light-brand/30 dark:hover:border-dark-brand/30 ${
                    isActive
                      ? "bg-light-brand/10 dark:bg-dark-brand/10 border-light-brand/30 dark:border-dark-brand/30"
                      : ""
                  }`
                }
              >
                <span className="text-light-brand dark:text-dark-brand">
                  <FaRegFileExcel size={22} />
                </span>
                <span className="font-medium">Import from Excel</span>
              </NavLink>
            </li>
          )}
        </ul>
      </nav>
      <button
        onClick={() => logout()}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-light-muted dark:text-dark-muted border-t border-light-border dark:border-dark-border hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors rounded"
      >
        <TbLogout2 className="text-lg" />
        Logout
      </button>

      <div className="p-3 text-xs text-light-muted dark:text-dark-muted border-t border-light-border dark:border-dark-border">
        © {new Date().getFullYear()} Nour Tune
      </div>
    </div>
  );
};

export default Sidebar;
